import { Cylinder, Sphere } from '@react-three/drei'
import { ThreeElements, ThreeEvent } from '@react-three/fiber'
import {
  MapFeaturePattern,
  TilesetMapFeatureStandardMaterial,
} from 'features/siteMapViz'
import { FC } from 'react'

interface PinMeshProps extends Omit<ThreeElements['group'], 'children'> {
  name: string
  hovered: boolean
  color?: string
  radius?: number
  onClick: (e: ThreeEvent<MouseEvent>) => void
}

export const PinMesh: FC<PinMeshProps> = ({
  name,
  hovered,
  onClick,
  color,
  radius,
  ...groupProps
}) => {
  const sphereRadius = radius ?? 20
  const cylinderRadius = 3
  const cylinderHeight = 60

  const cylinderPosition: [number, number, number] = [
    0,
    -sphereRadius - cylinderHeight / 2,
    0,
  ]

  return (
    <group name={name} onClick={onClick} {...groupProps}>
      <Sphere args={[sphereRadius]}>
        <TilesetMapFeatureStandardMaterial
          color={hovered ? 'white' : (color ?? 'red')}
          baseOpacity={1}
          pattern={MapFeaturePattern.Metallic}
          importantFaceLength={1}
        />
      </Sphere>
      <Cylinder
        args={[cylinderRadius, cylinderRadius, cylinderHeight]}
        position={cylinderPosition}>
        <TilesetMapFeatureStandardMaterial
          color={hovered ? 'white' : 'grey'}
          baseOpacity={1}
          pattern={MapFeaturePattern.Metallic}
          importantFaceLength={1}
        />
      </Cylinder>
    </group>
  )
}
